import { firebase } from '../../model/firebase/firebase';

export const authTypes = {
  ADMINSESSION: 'auth/ADMIN_IN',
  ADMINSIGNOUT: 'authorize/ADMIN_DEAUTHORIZE',
};

export const adminLogin = (uid, claim, user) => ({
  type: authTypes.ADMINSESSION,
  uid,
  claim,
  userData: { ...user },
});

export const adminLogout = () => ({
  type: authTypes.ADMINSIGNOUT,
});

export const startLogout = () => {
  return () => {
    return firebase.auth().signOut();
  };
};
